export default {
  title: {
    en: 'Tell us some specific details',
  },
  titlePlaceholder: {
    en: 'Title',
  },
  textPlaceholder: {
    en: `Example: The notes in the scent were exactly what I had imagined.
    It smelled just as spicy as I thought it would, I really love it and gets tons of compliments!`,
  },
}
